import { useState, useCallback } from "react";
import { useSelector } from "react-redux";

const useHttp = () => {
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const token = useSelector((state) => state.auth.token);

  const sendRequest = useCallback(async (requestConfig, responseData) => {
    setError(null);
    setStatus(null);

    try {
      var header = {
        "access-control-allow-origin": "*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      };

      const response = await fetch(requestConfig.url, {
        method: requestConfig.method ? requestConfig.method : "GET",
        headers: requestConfig.headers ? requestConfig.headers : header,
        body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
      });
      // console.log(response);
      setStatus(response.status);
      const data = await response.json();

      if (response.status === 200 || response.status === 202) {
        // data.append({ status: response.status });
        responseData(data);
      } else if (response.status === 404 || response.status === 401) {
        console.log("Helllo");
        setError(data.message || "something went wrong");
      } else if (response.status === 403) {
        setError(data.message || "something went wrong");
      } else {
        setError(data.message || "something went wrong");

        throw new Error("Request Failed");
      }
    } catch (e) {
      setError(e.message || "something went wrong");
      // console.log("akash" + e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    error,
    setError,
    status,
    sendRequest,
  };
};

export default useHttp;
